import React from 'react'
import resolveProps from '../../utils/resolveProps'
import { TextProps, BodyProps, CaptionProps } from './types'

const config = {
  types: [],
  modifiers: ['inverse', 'body', 'caption'],
  states: []
}

export default function Text(props: TextProps & (BodyProps | CaptionProps)  & React.HTMLProps<HTMLDivElement>) {
  const { body, caption, inverse, children, ...rest } = props
  return (
    <p {...rest} className={resolveProps(props, config, 'Text')}>
      {children}
    </p>
  )
}

